import { projectStore } from '@/store/project-store';
import { domainStore } from '@/store/domain-store';

// Checks permission regarding topic (e.g. creating thought, etc.)
export default function () {
  /**
   * returns correct label to use for topic (used as input field labels for example)
   * @returns string
   */
  function topicLabel() {
    const project = projectStore.getState().project;
    let label;
    if (project?.config?.topic_term) {
      label = domainStore.translate('discuss.general.topic.term.title.' + project.config.topic_term);
    }
    if (!label) {
      label = domainStore.translate('discuss.general.topic.title');
    }
    return label;
  }
  /**
   * returns correct not-found error message to use for topic
   * @returns string
   */
  function topicNotFound() {
    const project = projectStore.getState().project;
    let notFound;
    if (project?.config?.topic_term) {
      notFound = domainStore.translate('discuss.general.topic.term.message.not-found.' + project.config.topic_term);
    }
    if (!notFound) {
      notFound = domainStore.translate('discuss.general.topic.message.not-found');
    }
    return notFound;
  }
  /**
   * returns correct translation for "to topic" (used as generic label to open a topic)
   * @returns string
   */
  function topicGoTo() {
    const project = projectStore.getState().project;
    let goTo;
    if (project?.config?.topic_term) {
      goTo = domainStore.translate('discuss.general.topic.term.message.go-to.' + project.config.topic_term);
    }
    if (!goTo) {
      goTo = domainStore.translate('discuss.general.topic.message.go-to');
    }
    return goTo;
  }
  /**
   * returns correct translation for "in this topic" (used in sentences for voting messages)
   * @returns string
   */
  function topicInThis() {
    const project = projectStore.getState().project;
    let pre_string = 'dieser ';
    if (project?.config?.topic_term) {
      switch (project.config.topic_term) {
        case 'thema':
        case 'bereich':
        case 'ortsbezug':
        case 'zeitpunkt_des_verfahrens':
          pre_string = 'diesem ';
          break;
        default:
          pre_string = 'dieser ';
      }
    }
    return pre_string + topicLabel();
  }

  return {
    topicLabel,
    topicNotFound,
    topicGoTo,
    topicInThis,
  };
}
